module.exports = __webpack_public_path__ + "img/cassie-logo-black.3bd824d8.svg";